import React from 'react';
import { FadeIn } from './FadeIn';
import { Hourglass } from 'lucide-react';
export function UrgencySection() {
  return <section className="py-[50px] md:py-[80px] px-6 bg-brand-urgency relative overflow-hidden" data-id="element-184">
      {/* Subtle texture overlay */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-black to-transparent pointer-events-none" data-id="element-185"></div>

      <div className="max-w-[900px] mx-auto relative z-10" data-id="element-186">
        <FadeIn data-id="element-187">
          <div className="flex flex-col items-center text-center" data-id="element-188">
            <div className="bg-black/20 p-4 rounded-full mb-6" data-id="element-189">
              <Hourglass className="w-12 h-12 text-white" data-id="element-190" />
            </div>

            <h2 className="text-[32px] md:text-[38px] font-bold text-white mb-8 flex items-center justify-center gap-3" data-id="element-191">
              <span className="text-4xl" data-id="element-192">⚠️</span> Cada Día Que Esperas Te
              Cuesta Más
            </h2>

            <div className="text-[20px] text-white space-y-4 max-w-2xl mx-auto bg-black/20 p-8 rounded-2xl border border-white/10" data-id="element-193">
              <p data-id="element-194">Los precios de las pólizas suben con la edad.</p>
              <p className="font-semibold" data-id="element-195">
                Hoy tienes la oportunidad de asegurar la prima más baja posible.
              </p>
              <p className="italic text-white/80" data-id="element-196">
                Mañana puede ser diferente.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}